module.exports = __webpack_public_path__ + "img/icon_map_3_5_hg.784be185.png";